import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat.js";
import { isValidHour, isValidMinute } from "./date.js";
dayjs.extend(customParseFormat);
// Define the required format
const BOOKING_DATE_FORMAT = "YYYY-MM-DD";
export const isValidBookingDate = (value) => {
    // Check 1: Ensure the input is a string
    if (typeof value !== "string") {
        return false;
    }
    // Check 2: Attempt to parse the string using the specific format
    // The 'true' argument activates STRICT parsing, meaning the input
    // must match the format exactly.
    const dateObject = dayjs(value, BOOKING_DATE_FORMAT, true);
    // Check 3: Verify that the resulting Day.js object is valid
    return dateObject.isValid();
};
/**
 * Evaluates whether a booking is confirmed based on availability and scheduling completeness.
 *
 * A booking is considered confirmed when the respondent's availability is explicitly known
 * and a valid date, start time (hours & minutes), and end time (hours & minutes) are all set.
 *
 * @param booking - The booking object to check, or `null`.
 * @returns `true` if the booking contains complete and valid date/time details; `false` otherwise.
 */
export const isBookingConfirmed = (booking) => {
    if (!booking) {
        return false;
    }
    const { respondentAvailabilityIsKnown, date, startHours, startMinutes, endHours, endMinutes, } = booking;
    return (Boolean(respondentAvailabilityIsKnown) &&
        isValidBookingDate(date) &&
        isValidHour(startHours) &&
        isValidMinute(startMinutes) &&
        isValidHour(endHours) &&
        isValidMinute(endMinutes));
};
//# sourceMappingURL=booking.js.map